import styled from 'styled-components';

const InputContainer = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: flex-end;
  width: 100%;

  & > div {
    flex: 1;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
    
    button {
      height: 50px;
    }
  }
`;

export default InputContainer;
